import { useCallback } from 'react'
import type { Area } from 'react-easy-crop'
import { useResetOnChange } from './useResetOnChange'

// Crop/zoom state for a react-easy-crop dialog, reset per editing session.
//
// A session is one image open in one dialog: closing and reopening on the same
// file starts over, so a half-framed crop never bleeds into the next upload.
// The reset is keyed rather than done in an effect, so the Cropper never mounts
// against the previous image's viewport.
export function useCropSession(open: boolean, imageSrc: string | null) {
  const session = open && imageSrc ? imageSrc : null

  const [crop, setCrop] = useResetOnChange(session, () => ({ x: 0, y: 0 }))
  const [zoom, setZoom] = useResetOnChange(session, () => 1)
  const [areaPixels, setAreaPixels] = useResetOnChange<Area | null>(session, () => null)

  const onCropComplete = useCallback(
    (_: Area, pixels: Area) => setAreaPixels(pixels),
    [setAreaPixels],
  )

  return { session, crop, setCrop, zoom, setZoom, areaPixels, onCropComplete }
}
